@if (visible()) {
  <div class="user-inactive-backdrop" role="presentation">
    <div
      class="user-inactive-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="user-inactive-title"
      (click)="$event.stopPropagation()"
    >
      <button
        type="button"
        class="user-inactive-close"
        (click)="dismissed.emit()"
        aria-label="Close"
      >
        ×
      </button>
      <p class="user-inactive-brand">LaunchPocket</p>
      <div class="user-inactive-hero" aria-hidden="true">
        <span class="user-inactive-hero-icon">!</span>
      </div>

      <h2 id="user-inactive-title" class="user-inactive-title">Access disabled</h2>
      <p class="user-inactive-subtitle">
        Your access to <strong>{{ displayTenant() }}</strong> is disabled. Please contact the store owner.
      </p>

      @if ((tenantEmail() ?? '').trim()) {
        <div class="user-inactive-actions">
          <a class="btn btn-primary" [href]="mailtoHref()">
            Email store
            <span aria-hidden="true">→</span>
          </a>
          <p class="user-inactive-fallback">
            If the button doesn’t work, email the store at <strong>{{ tenantEmail() }}</strong>.
          </p>
        </div>
      }
    </div>
  </div>
}

